import React, { Component } from "react";
import main from "../../assets/images/main.jpg";

class FeelingProud extends Component {
  render() {
    return (
      <>
        <img className="greeting-image-div" src={main} alt="" />
      </>
    );
  }
}

export default FeelingProud;
